/**
 * Sync setup Work Packages from proven state.
 * Valid runway → Done. Unknown-proceed → Waived (never Done).
 *
 * Client migrate may invent seed WPs that are not on the API. Prefer
 * applySetupWorkPackageSync so callers share one write path; store.patch
 * upserts on PATCH 404 so ghost rows do not banner.
 */

export function syncSetupWorkPackages(state, derived, { today } = {}) {
  const packages = state?.workPackages || [];
  const patches = [];
  const cashOk = derived?.runway && !derived.runway.cashUnknown && !derived.runway.burnUnknown;
  const waived = !!state?.ui?.runwayUnknownProceed && !cashOk;
  const accountsOk = (state?.accounts || []).length > 0;

  for (const pkg of packages) {
    if (pkg.id === 'wp-runway-baseline') {
      if (cashOk && pkg.status !== 'Done') {
        patches.push({
          id: pkg.id,
          changes: {
            status: 'Done',
            disposition: 'completed',
            completedAt: today || pkg.completedAt,
            completionNote: 'Runway cash and burn recorded.',
          },
        });
      } else if (waived && pkg.status !== 'Waived' && pkg.status !== 'Done') {
        patches.push({
          id: pkg.id,
          changes: {
            status: 'Waived',
            disposition: 'proceeding_unknown',
            completedAt: today || pkg.completedAt,
            completionNote: 'Closed — baseline unavailable, founder elected to proceed.',
          },
        });
      }
    }
    if (pkg.id === 'wp-import-top50' && accountsOk && pkg.status !== 'Done') {
      patches.push({
        id: pkg.id,
        changes: {
          status: 'Done',
          disposition: 'completed',
          completedAt: today || pkg.completedAt,
          completionNote: 'Accounts imported.',
        },
      });
    }
  }

  return patches;
}

/** Apply setup WP completion patches through the store (404 → create). */
export function applySetupWorkPackageSync(state, derived, { today, patch } = {}) {
  const patches = syncSetupWorkPackages(state, derived, { today });
  for (const p of patches) {
    patch('workPackages', p.id, p.changes);
  }
  return patches;
}
